import { useContext, useState } from "react";
import BlockchainContext from "../store/BlockchainContext";
import { numberWithCommas, walletAddressSlicer } from "../utils/util";
import CopyToClipboard from "react-copy-to-clipboard";

const AffiliateSection = () => {
  const [copied, setCopied] = useState(false);
  const {
    refWithdraw,
    getAvailableRefInfo,
    userInvitedInfo,
    usdPrice,
    account,
    userTotalDeposits,
  } = useContext(BlockchainContext);

  const handlecopy = () => {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };
  return (
    <>
      <section className="panel_section">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-12">
              <div className="panel deposit mb-5">
                <h3>Affiliate Program</h3>
                <div className="row">
                  <div className="col-md-2 col-12">
                    <div className="roi_box vertical-center">
                      <h5>
                        Bonus
                        <br />
                        Level 1 = 10% <br /> Level 2 = 5%
                        <br /> Level 3 = 2%
                      </h5>
                    </div>
                  </div>
                  <div className="col-md-4 col-12 vertical-center">
                    <div className="w-100 input_box">
                      <h5 className="">Your Personal Link:</h5>
                      {account && userTotalDeposits > 0 ? (
                        <div className="input-group mb-0">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Not activated yet"
                            value={`https://${window.location.host}/?ref=${
                              account && walletAddressSlicer(account)
                            }`}
                            aria-describedby="button-addon2"
                          />
                          <CopyToClipboard
                            text={`https://${window.location.host}/?ref=${account}`}
                            onCopy={() => handlecopy()}
                          >
                            <button
                              className="btn btn-dark link-copy--btn"
                              type="button"
                              id="button-addon2"
                            >
                              Copy
                            </button>
                          </CopyToClipboard>
                        </div>
                      ) : (
                        <div className="input-group mb-0">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Not activated yet"
                            value="Not Activated Yet!"
                            aria-describedby="button-addon2"
                          />
                          <button
                            className="btn btn-dark"
                            type="button"
                            id="button-addon2"
                            disabled="true"
                          >
                            Copy
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-2 col-12 vertical-center">
                    <div className="info-col">
                      <h5>{userInvitedInfo[0]}</h5>
                      <h6 className="mb-0">Invited Users</h6>
                    </div>
                  </div>
                  <div className="col-md-2 col-6 vertical-center">
                    <div className="info-col">
                      <h5>{numberWithCommas(userInvitedInfo[1], 5)} MATIC</h5>
                      <span className="small">
                        ~ ${numberWithCommas(userInvitedInfo[1] * usdPrice, 2)}
                      </span>
                      <h6 className="mb-0">Total Referral Earnings</h6>
                    </div>
                  </div>
                  <div className="col-md-2 col-6">
                    <div className="button-col">
                      <div className="info-col text-center mb-2">
                        <h5>
                          {numberWithCommas(getAvailableRefInfo, 5)} MATIC
                        </h5>
                        <span className="small">
                          ~ $
                          {numberWithCommas(getAvailableRefInfo * usdPrice, 2)}
                        </span>
                        <h6 className="mb-0">Available Referral Earnings</h6>
                      </div>
                      <button
                        className="w-100 mb-2 btn-sm btn btn-outline-light"
                        onClick={() => refWithdraw()}
                      >
                        <span>Harvest</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AffiliateSection;
